import { Controller } from 'stimulus';

export default class extends Controller {
    static targets = [ 'star1', 'star2', 'star3', 'star4', 'star5', 'space_score', 'management_score', 'amenities_score' ];
    static values = { scoreType: String };

    connect() {
    }

    setScore(score) {
        let scoreType = this.scoreTypeValue;
        if (scoreType === 'space_score') {
            this.space_scoreTarget.value = score;
        } else if (scoreType === 'management_score') {
            this.management_scoreTarget.value = score;
        } else if (scoreType === 'amenities_score') {
            this.amenities_scoreTarget.value = score;
        } else {
            console.error('Invalid scoreType:', scoreType);
        }
    }

    star1Click(e) {
        e.preventDefault();
        this.star1Target.classList.add('bg-brand');
        this.star2Target.classList.remove('bg-brand');
        this.star3Target.classList.remove('bg-brand');
        this.star4Target.classList.remove('bg-brand');
        this.star5Target.classList.remove('bg-brand');
        this.setScore(1);
    }
    star2Click(e) {
        e.preventDefault();
        this.star1Target.classList.add('bg-brand');
        this.star2Target.classList.add('bg-brand');
        this.star3Target.classList.remove('bg-brand');
        this.star4Target.classList.remove('bg-brand');
        this.star5Target.classList.remove('bg-brand');
        this.setScore(2);
    }
    star3Click(e) {
        e.preventDefault();
        this.star1Target.classList.add('bg-brand');
        this.star2Target.classList.add('bg-brand');
        this.star3Target.classList.add('bg-brand');
        this.star4Target.classList.remove('bg-brand');
        this.star5Target.classList.remove('bg-brand');
        this.setScore(3);
    }
    star4Click(e) {
        e.preventDefault();
        this.star1Target.classList.add('bg-brand');
        this.star2Target.classList.add('bg-brand');
        this.star3Target.classList.add('bg-brand');
        this.star4Target.classList.add('bg-brand');
        this.star5Target.classList.remove('bg-brand');
        this.setScore(4);
    }
    star5Click(e) {
        e.preventDefault();
        this.star1Target.classList.add('bg-brand');
        this.star2Target.classList.add('bg-brand');
        this.star3Target.classList.add('bg-brand');
        this.star4Target.classList.add('bg-brand');
        this.star5Target.classList.add('bg-brand');
        this.setScore(5);
    }

}
